module.exports = __webpack_public_path__ + "static/00065.535c80a4.jpg";